import { useQuery } from 'react-query';
import { getDeviceList } from 'lib/api/device';
import { useState } from 'react';
import useLoginCheck from 'hooks/common/useLoginCheck';

const useDeviceList = () => {
  const [addDeviceListPage, setAddDeviceListPage] = useState(1);
  const [deviceListPage, setDeviceListPage] = useState(1);
  const [addDeviceListSearch, setAddDeviceListSearch] = useState('');
  const [deviceListSearch, setDeviceListSearch] = useState('');

  const { isLoading, error, data, refetch } = useQuery(
    [
      'deviceList',
      addDeviceListPage,
      deviceListPage,
      addDeviceListSearch,
      deviceListSearch,
    ],
    () =>
      getDeviceList({
        addDeviceListPage,
        deviceListPage,
        addDeviceListSearch,
        deviceListSearch,
      }),
    {
      keepPreviousData: true,
    },
  );

  useLoginCheck(error?.response, refetch);

  const addDeviceList = data?.data.addDeviceList;
  const addDeviceListTotalPage = Math.ceil(addDeviceList?.count / 5);
  const deviceList = data?.data.deviceList;
  const deviceListTotalPage = Math.ceil(deviceList?.count / 5);

  const onSearchDeviceList = e => {
    setDeviceListSearch(e.target.value);
    setDeviceListPage(1);
  };

  const onSearchAddDeviceList = e => {
    setAddDeviceListSearch(e.target.value);
    setAddDeviceListPage(1);
  };

  return {
    addDeviceListPage,
    deviceListPage,
    addDeviceListSearch,
    deviceListSearch,
    isLoading,
    error,
    addDeviceList,
    addDeviceListTotalPage,
    deviceList,
    deviceListTotalPage,
    setAddDeviceListPage,
    setDeviceListPage,
    onSearchAddDeviceList,
    onSearchDeviceList,
  };
};

export default useDeviceList;
